import { useTranslation } from 'react-i18next';
import TableActionIcon from '@/components/ui/ActionIcon/TableActionIcon';
import OpenInquiryButton from '@/components/Inquiries/OpenInquiryButton';
import childrenIcon from '@/assets/icons/children.svg';
import paymentIcon from '@/assets/icons/payment-card.svg';
import certificateIcon from '@/assets/icons/support-certificate.svg';
import idIcon from '@/assets/icons/id2.svg';
import SupportedDtoIn from '@/models/in/SupportedDtoIn';

interface SupportedsRowActionsProps {
  supported: SupportedDtoIn;
  onAddChildren: (supportedId: number) => void;
  onAddPaymentInfo: (supportedId: number) => void;
  onSupportCertificate: (supported: SupportedDtoIn) => void;
  /** «בקשה לתיקון מספר זהות» (HAT-1428). Left out while the feature is off for the fund. */
  onRequestIdChange?: (supported: SupportedDtoIn) => void;
}

/** The row's action icons: children, payment details, certificate, an ID correction request and opening an inquiry. */
const SupportedsRowActions = ({ supported, onAddChildren, onAddPaymentInfo, onSupportCertificate, onRequestIdChange }: SupportedsRowActionsProps) => {
  const { t } = useTranslation();

  return (
    <div className="flex items-center gap-[6px] flex-nowrap">
      <TableActionIcon title={t('children')} onClick={() => onAddChildren(supported.id)}>
        <img src={childrenIcon} alt="" className="w-[22px] h-[22px]" />
      </TableActionIcon>
      <TableActionIcon title={t('paymentDetails')} onClick={() => onAddPaymentInfo(supported.id)}>
        <img src={paymentIcon} alt="" className="w-[22px] h-[22px]" />
      </TableActionIcon>
      <TableActionIcon title={t('supportCertificate.title')} onClick={() => onSupportCertificate(supported)}>
        <img src={certificateIcon} alt="" className="w-[22px] h-[22px]" />
      </TableActionIcon>
      {onRequestIdChange && (
        <TableActionIcon title={t('israeliIdChangeRequest.title')} onClick={() => onRequestIdChange(supported)}>
          <img src={idIcon} alt="" className="w-[22px] h-[22px]" />
        </TableActionIcon>
      )}
      <OpenInquiryButton resourceType="Supported" resourceId={String(supported.id)} size="medium" />
    </div>
  );
};

export default SupportedsRowActions;
